import { render } from "./MkContact.vue?vue&type=template&id=867d8842&scoped=true"
import script from "./MkContact.vue?vue&type=script&lang=js"
export * from "./MkContact.vue?vue&type=script&lang=js"

import "./MkContact.vue?vue&type=style&index=0&id=867d8842&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-867d8842"]])

export default __exports__